import Settings from '../../../../../../settings/Settings';

const NAME = {
    FONT: Settings.FONTS.LXGW_CYRILLIC_BOLD,
    SIZE: 50,
    TINT: 0x1c2229,
};

const LEVEL = {
    FONT: Settings.FONTS.LXGW_CYRILLIC_BOLD,
    SIZE: 50,
    TINT: 0x009bcc,
};

const GOLD = {
    FONT: Settings.FONTS.LXGW_CYRILLIC_BOLD,
    SIZE: 50,
    TINT: 0x1c2229,
};

export default class Player extends Phaser.GameObjects.Container {
    private config: any;
    private avatar!: Phaser.GameObjects.Image;
    private playerName!: Phaser.GameObjects.BitmapText;
    private level!: Phaser.GameObjects.BitmapText;
    private gold!: Phaser.GameObjects.BitmapText;

    constructor(scene: Phaser.Scene, x: number, y: number, config: any) {
        super(scene, x, y);

        this.config = config;

        this.setupAvatar();
        this.setupName();
        this.setupLevel();
        this.setupKills();
    }

    setupAvatar() {
        let x = 0;
        let y = 4;
        let frame = 'gui/leaderboard/avatar';

        this.avatar = this.scene.add.image(x, y, 'atlas', frame);
        this.add(this.avatar);
    }

    setupName() {
        let x = 55;
        let y = -20;
        let text = this.config.player_platform.telegram.first_name;

        this.playerName = this.scene.add.bitmapText(x, y, NAME.FONT, text, NAME.SIZE);
        this.playerName.setOrigin(0, 0.5);
        this.playerName.setTint(NAME.TINT);
        this.add(this.playerName);
    }

    setupLevel() {
        let x = 55;
        let y = 20;
        let text = '(telegram)'; //`LVL ${this.config.level}`;

        this.level = this.scene.add.bitmapText(x, y, LEVEL.FONT, text, LEVEL.SIZE);
        this.level.setOrigin(0, 0.5);
        this.level.setTint(LEVEL.TINT);
        this.add(this.level);
    }

    setupKills() {
        let x = 300;
        let y = 0;
        let frame = 'gui/common/coin_43';

        // this.icon = this.scene.add.image(x, y, 'atlas', frame);
        // this.add(this.icon);

        x = 335;
        let text = this.config.score_weekly;

        this.gold = this.scene.add.bitmapText(x, y, GOLD.FONT, text, GOLD.SIZE);
        this.gold.setOrigin(0, 0.5);
        this.gold.setTint(GOLD.TINT);
        this.add(this.gold);
    }
}
